import React from 'react';
import { Line, LineChart, ResponsiveContainer } from 'recharts';
import styles from './Overview.module.scss';
import StackedProgressBar from 'components/StackedProgressBar/StackedProgressBar';
import Chip from 'components/Chip/Chip';
import { LINE_DATA } from '../../../../data/overviewData';

interface TableData {
  id: number;
  risk: number;
  title: string;
  total: number;
  today: number;
  status: string;
  statusCount: number;
  percent: number;
  dynamics: string;
}

const TableView = (props: any) => {
  const { headerValues, columnData } = props;

  const renderDot = (risk: number) => {
    const dotColor = () => {
      switch (risk) {
        case 1:
          return "bg-blue-500";
        case 2:
          return "bg-teal-600";
        case 3:
          return "bg-error";
        case 5:
          return "bg-green-600";
        case 6:
          return "bg-pink-500";
        case 7:
          return "bg-purple-500";
        default:
          return "bg-warning-400";
      }
    };

    return <span className={`mr-2 ${styles.dot} ${dotColor()}`}></span>;
  };

  return (
    <div className="table-responsive mh-3">
      <table className="w-100">
        <thead>
          <tr className={styles.tHeader}>
            {headerValues.map((value: string, i: number) => (
              <th key={i} className={`${[4, 5].includes(i) ? 'text-center' : ''} text-uppercase text-gray-400 fw-700`}>
                {value}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="text-white fw-300 text-1x">
          {columnData.map((data: TableData) => (
            <tr key={data.id}>
              <td>
                <div className="d-flex">
                  {renderDot(data.risk)}
                  <p className="gray-50 mv-0">{data.title}</p>
                </div>
              </td>
              <td className="white-space-nowrap">{data.total}</td>
              <td className="white-space-nowrap">{data.today}</td>
              <td>
                <StackedProgressBar variant={data.status} progressCount={data.statusCount} />
              </td>
              <td className="text-center">{data.percent}</td>
              <td className="text-info text-center">+{data.dynamics}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default function OverviewContent() {
  const dataValues1 = [
    {
      id: 1,
      title: 'Cyber',
      total: '597989',
      today: '120430',
      status: 'info',
      statusCount: 5,
      percent: 438,
      dynamics: 10,
      risk: 1
    },
    {
      id: 2,
      title: 'Environmental',
      total: '543409',
      today: '120',
      status: 'warning',
      statusCount: 4,
      percent: 321,
      dynamics: 10,
      risk: 2
    },
    {
      id: 3,
      title: 'Finance',
      total: '467320',
      today: '3210',
      status: 'error',
      statusCount: 1,
      percent: 210,
      dynamics: 10,
      risk: 3
    },
    {
      id: 4,
      title: 'Fraud',
      total: '320210',
      today: '90',
      status: 'warning',
      statusCount: 3,
      percent: 198,
      dynamics: 10,
      risk: 4
    }
  ];

  const dataValues2 = [
    {
      id: 1,
      title: 'HR',
      total: '543 409',
      today: '120',
      status: 'warning',
      statusCount: 3,
      percent: 321,
      dynamics: 10,
      risk: 5
    },
    {
      id: 2,
      title: 'Operations',
      total: '467 320',
      today: '3 210',
      status: 'error',
      statusCount: 1,
      percent: 210,
      dynamics: 10,
      risk: 6
    },
    {
      id: 3,
      title: 'Regulatory',
      total: '597 989',
      today: '120 430',
      status: 'info',
      statusCount: 5,
      percent: 438,
      dynamics: 10,
      risk: 7
    },
    {
      id: 4,
      title: 'Tax',
      total: '320 210',
      today: '90',
      status: 'info',
      statusCount: 5,
      percent: 198,
      dynamics: 10,
      risk: 8
    }
  ];

  return (
    <div className="widget mt-5">
      <div className="row mt-5">
        <div className="col-2">
          <div className="row ph-5 mt-4">
            <div className="col">
              <h3 className={styles.title}>Total Risks</h3>
              <span className={styles.value}>203</span>
              <p className="text-7s text-gray-62">Current Month</p>
            </div>
            <div className="col">
              <ResponsiveContainer width="100%">
                <LineChart height={50} data={LINE_DATA}>
                  <Line type="monotone" dataKey="value" dot={false} stroke="#FFFFFF" strokeWidth={2} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        <div className="col-4">
          <TableView headerValues={['Risk Group', 'Total', 'Today', 'Status', 'Percent', 'Dynamics']} columnData={dataValues1} />
        </div>
        <div className="col-4 mh-5">
          <TableView headerValues={['Parameter', 'Total', 'Today', 'Status', 'Percent', 'Dynamics']} columnData={dataValues2} />
        </div>
        <div className="col-1">
          <div className="row mt-4">
            <div className="col">
              <h3 className={styles.title}>Risks Mitigated</h3>
              <div className={`${styles.value} d-flex`}>
                132
                <div className="mh-4 mt-1" style={{ lineHeight: "0.9em" }}>
                  <Chip
                    type="fill" variant="light">
                    27
                    <i className="pl-5 pv-2 icon-arrow-up-circle"></i>
                  </Chip>
                </div>
              </div>
              <p className="text-7s text-gray-62">Current Month</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
